"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("@angular/common");
const core_1 = require("@angular/core");
const forms_1 = require("@angular/forms");
const idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
const idm_export_client_js_1 = require("@synisys/idm-export-client-js");
const idm_ng_controls_1 = require("@synisys/idm-ng-controls");
const idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
const idm_xml_template_builder_1 = require("@synisys/idm-xml-template-builder");
const export_data_proccessing_service_1 = require("../controls/export/export-data-proccessing-service");
const reporting_controls_module_1 = require("../controls/reporting-controls.module");
const material_module_1 = require("../material.module");
const message_with_placeholder_pipe_1 = require("../shared/message-with-placeholder.pipe");
const area_timeline_builder_component_1 = require("./chart/area-timeline/builder/area-timeline-builder.component");
const area_timeline_view_component_1 = require("./chart/area-timeline/view/area-timeline-view.component");
const categorical_chart_designer_component_1 = require("./chart/categorical-chart/categorical-chart-designer.component");
const categorical_chart_view_component_1 = require("./chart/categorical-chart/categorical-chart-view.component");
const chart_export_menu_component_1 = require("./chart/chart-export-menu/chart-export-menu.component");
const combination_chart_builder_component_1 = require("./chart/combination-chart/builder/combination-chart-builder.component");
const combination_chart_view_component_1 = require("./chart/combination-chart/view/combination-chart-view.component");
const pie_chart_builder_component_1 = require("./chart/pie-chart/pie-chart-builder.component");
const pie_chart_view_component_1 = require("./chart/pie-chart/pie-chart-view.component");
const radar_chart_builder_component_1 = require("./chart/radar-chart/builder/radar-chart-builder.component");
const radar_chart_view_component_1 = require("./chart/radar-chart/view/radar-chart-view.component");
const scorecard_chart_builder_component_1 = require("./chart/scorecard-chart/builder/scorecard-chart-builder.component");
const scorecard_chart_view_component_1 = require("./chart/scorecard-chart/view/scorecard-chart-view.component");
const serpentine_timeline_builder_component_1 = require("./chart/serpentine-timeline/builder/serpentine-timeline-builder.component");
const serpentine_timeline_view_component_1 = require("./chart/serpentine-timeline/view/serpentine-timeline-view.component");
const chart_data_table_component_1 = require("./chart/shared/component/chart-data-table.component");
const speedometer_chart_designer_component_1 = require("./chart/speedometer-chart/speedometer-chart-designer.component");
const speedometer_chart_view_component_1 = require("./chart/speedometer-chart/speedometer-chart-view.component");
const list_builder_component_1 = require("./list/list-builder.component");
const list_view_component_1 = require("./list/list-view.component");
const page_filter_service_1 = require("./page-filter/service/page-filter.service");
const sis_report_export_dialog_1 = require("./report-export-dialog/sis-report-export.dialog");
const report_export_menu_component_1 = require("./report-export-menu/report-export-menu.component");
const report_invalid_state_view_component_1 = require("./report-invalid-state-view/report-invalid-state-view.component");
const rich_text_builder_component_1 = require("./rich-text/builder/rich-text-builder.component");
const SafeHtmlPipe_1 = require("./rich-text/pipe/SafeHtmlPipe");
const rich_text_component_1 = require("./rich-text/rich-text.component");
const rich_text_view_component_1 = require("./rich-text/view/rich-text-view.component");
const common_settings_module_1 = require("./shared/common-settings.module");
require("@synisys/synergy-design-system");
const report_error_state_view_component_1 = require("./report-error-state-view/report-error-state-view.component");
const sis_formatting_rules_listing_component_1 = require("./chart/shared/component/formatting-rules-listing-component/sis-formatting-rules-listing-component");
const sis_formatting_component_1 = require("./chart/shared/component/formatting/sis-formatting.component");
const sis_text_style_component_1 = require("./chart/shared/component/text-style/sis-text-style.component");
const boolean_operator_names_factory_1 = require("./chart/shared/service/boolean-operator-names-factory");
const condition_text_generator_service_1 = require("./chart/shared/service/condition-text-generator-service");
const operator_message_key_pipe_1 = require("./chart/shared/service/operator-message-key.pipe");
const operator_type_pipe_1 = require("./chart/shared/service/operator-type.pipe");
const condition_style_pipe_1 = require("./chart/shared/service/condition-style.pipe");
const condition_formatting_info_pipe_1 = require("./chart/shared/service/condition-formatting-info.pipe");
const report_export_delimiter_dialog_1 = require("./report-export-delimiter-dialog/report-export-delimiter.dialog");
/**
 * Created by mariam.melkonyan on 5/26/17.
 */
function pageFilterFactory() {
    return page_filter_service_1.PageFilterService.getInstance();
}
exports.pageFilterFactory = pageFilterFactory;
let ReportingViewsModule = class ReportingViewsModule {
};
ReportingViewsModule = __decorate([
    core_1.NgModule({
        imports: [
            common_1.CommonModule,
            idm_ng_controls_1.ControlsModule,
            forms_1.FormsModule,
            material_module_1.MaterialModule,
            reporting_controls_module_1.ReportingControlsModule,
            forms_1.ReactiveFormsModule,
            common_settings_module_1.CommonSettingsModule,
            idm_xml_template_builder_1.MultilingualEditorModule
        ],
        declarations: [
            categorical_chart_view_component_1.CategoricalChartViewComponent,
            categorical_chart_designer_component_1.CategoricalChartDesignerComponent,
            pie_chart_view_component_1.PieChartViewComponent,
            list_view_component_1.ListViewComponent,
            list_builder_component_1.ListBuilderComponent,
            pie_chart_builder_component_1.PieChartBuilderComponent,
            report_export_menu_component_1.ReportExportMenuComponent,
            chart_export_menu_component_1.ChartExportMenuComponent,
            report_invalid_state_view_component_1.ReportInvalidStateViewComponent,
            report_error_state_view_component_1.ReportErrorStateViewComponent,
            speedometer_chart_designer_component_1.SpeedometerChartDesignerComponent,
            speedometer_chart_view_component_1.SpeedometerChartViewComponent,
            sis_report_export_dialog_1.SisReportExportDialog,
            message_with_placeholder_pipe_1.MessageWithPlaceholderPipe,
            chart_data_table_component_1.ChartDataTableComponent,
            rich_text_component_1.RichTextComponent,
            rich_text_builder_component_1.RichTextBuilderComponent,
            rich_text_view_component_1.RichTextViewComponent,
            SafeHtmlPipe_1.SafeHtmlPipe,
            serpentine_timeline_view_component_1.SerpentineTimelineViewComponent,
            serpentine_timeline_builder_component_1.SerpentineTimelineBuilderComponent,
            area_timeline_builder_component_1.AreaTimelineBuilderComponent,
            area_timeline_view_component_1.AreaTimelineViewComponent,
            radar_chart_builder_component_1.RadarChartBuilderComponent,
            radar_chart_view_component_1.RadarChartViewComponent,
            combination_chart_builder_component_1.CombinationChartBuilderComponent,
            combination_chart_view_component_1.CombinationChartViewComponent,
            scorecard_chart_view_component_1.ScorecardChartViewComponent,
            scorecard_chart_builder_component_1.ScorecardChartBuilderComponent,
            sis_formatting_rules_listing_component_1.SisFormattingRulesListingComponent,
            sis_formatting_component_1.SisFormattingComponent,
            sis_text_style_component_1.SisTextStyleComponent,
            operator_message_key_pipe_1.OperatorMessageKeyPipe,
            operator_type_pipe_1.OperatorTypePipe,
            condition_style_pipe_1.ConditionStylePipe,
            condition_formatting_info_pipe_1.ConditionFormattingInfoPipe,
            report_export_delimiter_dialog_1.ReportExportDelimiterDialogComponent
        ],
        exports: [
            categorical_chart_view_component_1.CategoricalChartViewComponent,
            categorical_chart_designer_component_1.CategoricalChartDesignerComponent,
            pie_chart_view_component_1.PieChartViewComponent,
            list_view_component_1.ListViewComponent,
            list_builder_component_1.ListBuilderComponent,
            pie_chart_builder_component_1.PieChartBuilderComponent,
            report_export_menu_component_1.ReportExportMenuComponent,
            chart_export_menu_component_1.ChartExportMenuComponent,
            report_invalid_state_view_component_1.ReportInvalidStateViewComponent,
            report_error_state_view_component_1.ReportErrorStateViewComponent,
            speedometer_chart_designer_component_1.SpeedometerChartDesignerComponent,
            speedometer_chart_view_component_1.SpeedometerChartViewComponent,
            common_settings_module_1.CommonSettingsModule,
            sis_report_export_dialog_1.SisReportExportDialog,
            message_with_placeholder_pipe_1.MessageWithPlaceholderPipe,
            chart_data_table_component_1.ChartDataTableComponent,
            rich_text_component_1.RichTextComponent,
            rich_text_builder_component_1.RichTextBuilderComponent,
            rich_text_view_component_1.RichTextViewComponent,
            SafeHtmlPipe_1.SafeHtmlPipe,
            serpentine_timeline_view_component_1.SerpentineTimelineViewComponent,
            serpentine_timeline_builder_component_1.SerpentineTimelineBuilderComponent,
            area_timeline_builder_component_1.AreaTimelineBuilderComponent,
            area_timeline_view_component_1.AreaTimelineViewComponent,
            radar_chart_builder_component_1.RadarChartBuilderComponent,
            radar_chart_view_component_1.RadarChartViewComponent,
            combination_chart_builder_component_1.CombinationChartBuilderComponent,
            combination_chart_view_component_1.CombinationChartViewComponent,
            scorecard_chart_view_component_1.ScorecardChartViewComponent,
            scorecard_chart_builder_component_1.ScorecardChartBuilderComponent,
            sis_formatting_rules_listing_component_1.SisFormattingRulesListingComponent,
            sis_formatting_component_1.SisFormattingComponent,
            sis_text_style_component_1.SisTextStyleComponent,
            operator_message_key_pipe_1.OperatorMessageKeyPipe,
            operator_type_pipe_1.OperatorTypePipe,
            condition_style_pipe_1.ConditionStylePipe,
            condition_formatting_info_pipe_1.ConditionFormattingInfoPipe,
            report_export_delimiter_dialog_1.ReportExportDelimiterDialogComponent
        ],
        providers: [
            export_data_proccessing_service_1.ExportDataProcessingService,
            idm_export_client_js_1.HttpExportService,
            idm_dataset_service_client_js_1.HttpPathFormsService,
            { provide: idm_report_export_service_client_js_1.ReportExportService, useClass: idm_report_export_service_client_js_1.HttpReportExportService },
            { provide: idm_export_client_js_1.ExportService, useClass: idm_export_client_js_1.HttpExportService },
            { provide: page_filter_service_1.PageFilterService, useFactory: pageFilterFactory },
            boolean_operator_names_factory_1.BooleanOperatorNamesFactory,
            condition_text_generator_service_1.ConditionTextGeneratorService
        ],
        entryComponents: [
            sis_report_export_dialog_1.SisReportExportDialog,
            report_export_delimiter_dialog_1.ReportExportDelimiterDialogComponent
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA],
    })
], ReportingViewsModule);
exports.ReportingViewsModule = ReportingViewsModule;
__export(require("./chart/pie-chart/shared/pie-chart.model"));
__export(require("./chart/pie-chart/shared/pie-chart-report.model"));
__export(require("./chart/categorical-chart/shared/categorical-chart.model"));
__export(require("./chart/categorical-chart/shared/categorical-chart-report.model"));
__export(require("./chart/categorical-chart/shared/categorical-chart-options.model"));
__export(require("./list/shared/list.model"));
__export(require("./list/shared/list-report.model"));
__export(require("./list/list-options.model"));
__export(require("./list/list-export-settings.model"));
__export(require("./chart/pie-chart/shared/pie-chart-options.model"));
__export(require("./chart/serpentine-timeline/model/serpentine-timeline.model"));
__export(require("./chart/serpentine-timeline/model/serpentine-timeline-report.model"));
__export(require("./chart/serpentine-timeline/model/serpentine-timeline-report.model"));
//# sourceMappingURL=reporting-view.module.js.map